import Navigation from '../../../components/layout/Navigation';
import Footer from '../../../components/layout/Footer';
import Hero from '../../../components/ui/Hero';
import Section from '../../../components/ui/Section';
import FeatureGrid from '../../../components/ui/FeatureGrid';
import ProcessTimeline from '../../../components/ui/ProcessTimeline';
import CTA from '../../../components/ui/CTA';

export default function AIPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <Hero 
        title={<>Empower Your Business with <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">AI & Agentic Solutions</span></>}
        description="We deploy intelligent systems that learn, adapt, and automate, transforming your operations and customer interactions."
        bgImage="/assets/futuristic-ai-nn.png"
        primaryBtn={{ text: "Explore Possibilities", link: "/contact", icon: "ri-robot-line" }}
        secondaryBtn={{ text: "View Success Stories", link: "/services", icon: "ri-play-line" }}
      />

      <Section>
        <FeatureGrid 
          title="Intelligent Solutions for Every Function"
          subtitle="Discover how our specialized AI and automation services can revolutionize your business."
          items={[
            { title: 'AI Integrated Social Media', description: 'Leverage AI to amplify your brand\'s voice and drive meaningful connections.', icon: 'ri-share-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'AI Optimized PPC', description: 'Craft and continuously optimize Pay-Per-Click campaigns that drive targeted traffic.', icon: 'ri-advertisement-line', color: 'from-orange-500 to-red-500' },
            { title: 'AI Google Ads', description: 'Transform Google Ads into a precision-targeted, high-performing growth engine.', icon: 'ri-google-line', color: 'from-purple-500 to-pink-500' },
            { title: 'AI Process Automation', description: 'Streamline your business operations with intelligent automation solutions.', icon: 'ri-robot-line', color: 'from-green-500 to-teal-500' }
          ]}
          columns={2}
        />
      </Section>

      <Section className="bg-gray-900">
        <ProcessTimeline 
          title="Human-Centric AI for Real-World Impact"
          subtitle="We believe that the most effective AI solutions are those that seamlessly integrate with and augment human capabilities."
          steps={[
            { title: 'Discovery', description: 'Understanding your specific business challenges.', icon: 'ri-search-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Analysis', description: 'Data feasibility and opportunity mapping.', icon: 'ri-bar-chart-line', color: 'from-cyan-500 to-teal-500' },
            { title: 'Design', description: 'Designing intuitive, ethical AI architectures.', icon: 'ri-palette-line', color: 'from-teal-500 to-green-500' },
            { title: 'Development', description: 'Building and training custom models.', icon: 'ri-code-line', color: 'from-green-500 to-yellow-500' },
            { title: 'Optimization', description: 'Continuous monitoring and refinement.', icon: 'ri-rocket-line', color: 'from-yellow-500 to-orange-500' }
          ]}
        />
      </Section>

      <CTA 
        title={<>Ready to Transform Your Business <span className="bg-gradient-to-r from-purple-300 to-pink-300 bg-clip-text text-transparent">with Intelligence?</span></>}
        description="Partner with Hash Adz to integrate intelligent AI solutions that drive efficiency and growth."
        primaryBtn={{ text: "Request Consultation", link: "/contact" }}
        secondaryBtn={{ text: "View Success Stories", link: "/work" }}
        stats={[
          { number: '500%', label: 'Efficiency Boost' },
          { number: '200+', label: 'AI Solutions' },
          { number: '24/7', label: 'Intelligent Support' },
          { number: '5+', label: 'Years Expertise' }
        ]}
      />

      <Footer />
    </div>
  );
}